// ── Shared TV scene registry ──────────────────────────────────────────────
// The SINGLE source of truth for the TV channels, used by BOTH the remote
// (/tvcontrol) and the remote-controlled display (/tv?screen=N → ControlledTv-
// Screen). These are the exact same six real channels the TV Monitor tab
// exposes, plus Rotate. Keep scene changes in ONE place so the panel and the
// TVs never drift apart.
export const TV_SCENES = [
  { key: 'scores',     label: 'Live Scores',       icon: '🏆' },
  { key: 'brackets',   label: 'Flight Brackets',   icon: '🗂️' },
  { key: 'matchboard', label: 'Live Leaderboard',  icon: '📋' },
  { key: 'scrollmap',  label: 'Course Scroll Map', icon: '🗺️' },
  { key: 'photos',     label: 'Photo Wall',        icon: '📸' },
  { key: 'split',      label: 'Split',             icon: '🔀' },
  { key: 'rotate',     label: 'Rotate',            icon: '🔁' },
]

// Calcutta TV scenes — driven by the SEPARATE Calcutta control (in the Calcutta
// tab), not the tournament TV panel. Kept OUT of TV_SCENES so they never appear
// as tournament channels, but their keys ARE valid /tv modes so the same shared
// TV pool + /tv?screen=N pipeline renders them.
export const CALCUTTA_TV_SCENES = [
  { key: 'calcutta-board',     screen: 'board',     label: 'Auction Board',  icon: '🎙️', sub: 'Full flight — prices fill in as sold' },
  { key: 'calcutta-spotlight', screen: 'spotlight', label: 'Team Spotlight', icon: '⭐', sub: 'The team on the block, big' },
  { key: 'calcutta-results',   screen: 'results',   label: 'Flight Results', icon: '🏆', sub: '1st & 2nd + payouts (never MGA)' },
  { key: 'calcutta-sold',      screen: 'sold',      label: 'Sold Board',     icon: '💰', sub: 'Every team with its final price' },
  { key: 'calcutta-upnext',    screen: 'upnext',    label: 'Up Next',        icon: '⏭️', sub: 'The next flight to the block' },
  { key: 'calcutta-title',     screen: 'title',     label: 'Title Card',     icon: '🎬', sub: 'Clean intro between flights' },
]

export const VALID_TV_MODES = [...TV_SCENES.map((s) => s.key), ...CALCUTTA_TV_SCENES.map((s) => s.key)]

// Calcutta TVs are a SEPARATE pool, marked with a trailing "C" (…/tv?screen=1C).
// The tournament TV control HIDES these; the Calcutta control shows ONLY these.
// No overlap either direction.
export const isCalcuttaScreen = (id) => /c$/i.test(String(id || ''))

// A Calcutta "C" TV in Rotate mode cycles these (mirrors TV_ROTATE_ORDER for the
// tournament pool).
export const CALCUTTA_ROTATE_ORDER = ['calcutta-board', 'calcutta-sold', 'calcutta-upnext']

// Rotate cycles the three primary boards (scrolling map, not the static one).
export const TV_ROTATE_ORDER = ['scores', 'photos', 'scrollmap']

// Back-compat: screens set before the scene rename stored 'leaderboard'/'map'.
const LEGACY_MODE_ALIAS = { leaderboard: 'scores', map: 'scrollmap' }

export function normalizeTvMode(mode) {
  const m = LEGACY_MODE_ALIAS[mode] || mode
  return VALID_TV_MODES.includes(m) ? m : 'rotate'
}
